<template>
	<div class="search_area mb_20">
		<input
			type="text"
			v-model="searchKeyword"
			:placeholder="$t('input.placeholder.search_assets')"
		/>
		<a class="search_icon SEARCH"></a>
	</div>

	<div class="slide_area mb_30">
		<swiper
			:navigation="sliderNavigation"
			:slides-per-view="slidesPerView"
			:slides-per-group="slidesPerGroup"
			:space-between="spaceBetween"
			:centered-slides="centeredSlides"
			:slides-offset-before="slidesOffsetBefore"
			:modules="modules"
			:initialSlide="initialSlide"
		>
			<swiper-slide v-for="item in account_list" :key="item.seq"
				><input
					type="radio"
					:id="item.code"
					class="radio_asset"
					v-model="accountSeq"
					name="asset"
					:value="item.seq"
					@change="$emit('changeAccount', item.seq)"
				/>
				<label class="asset_box type01 box" :for="item.code">
					<span :class="[item.code, 'large']"></span>
					<div :class="['d_flex', isMobile ? 'mt_5' : 'mt_15']">
						<span class="code">{{ item.code }}</span>
						<span class="name">{{ item.asset_title }}</span>
					</div>
				</label>
			</swiper-slide>
		</swiper>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Navigation } from 'swiper';
import { filter } from 'lodash';

export default {
	name: 'account-picker',
	emits: ['changeAccount'],
	data() {
		return {
			searchKeyword: '',
			accountSeq: null,
			modules: [Navigation],
			sliderNavigation: true,
			slidesPerView: 4,
			slidesPerGroup: 4,
			spaceBetween: 10,
			centeredSlides: false,
			slidesOffsetBefore: 0,
			isMobile: false,
		};
	},
	computed: {
		...mapGetters('account', ['accounts']),
		account_list() {
			return filter(this.accounts, account => {
				return (
					account.code
						.toLowerCase()
						.includes(this.searchKeyword.toLowerCase()) ||
					account.asset_title
						.toLowerCase()
						.includes(this.searchKeyword.toLowerCase())
				);
			});
		},
		initialSlide() {
			if (this.$route.query.accountSeq) {
				return this.accounts.findIndex(item => {
					return item.seq === parseInt(this.$route.query.accountSeq);
				});
			} else {
				return 0;
			}
		},
	},
	methods: {
		checkMobile() {
			this.isMobile = window.innerWidth <= 768;
			// Swiper 설정도 동적으로 업데이트
			if (this.isMobile) {
				this.slidesPerView = 'auto';
				this.slidesPerGroup = 1;
				this.spaceBetween = 10;
			} else {
				this.slidesPerView = 4;
				this.slidesPerGroup = 4;
				this.spaceBetween = 10;
			}
			this.sliderNavigation = !this.isMobile;
			// 모바일에서 슬라이드 수가 적을 때 왼쪽 정렬
			this.centeredSlides = false;
			this.slidesOffsetBefore = 0;
		},
	},
	created() {
		this.accountSeq = this.$route.query.accountSeq || null;
	},
	mounted() {
		this.checkMobile();
		window.addEventListener('resize', this.checkMobile);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.checkMobile);
	},
};
</script>
